module.exports = __webpack_public_path__ + "bc3a31c55942dc3b8be637095b9900b5.jpg";